import {FooterLinkClickEvent} from '@wf-components/footer-consumer';
import {EpicGamesFooter} from '@wf-components/footer-react';
import React, {useCallback} from 'react';
import {generateRoutePath, getLocale} from '@epic-core/common';
import {useNavigate} from 'react-router';
import root from 'window-or-global';
import {useAccountCountry} from 'epic-ue-shared';

export const FooterWrapper = (): JSX.Element | null => {
    const locale = getLocale();
    const navigate = useNavigate();
    const accountCountry = useAccountCountry();

    const clientConfig = root.clientEnvConfig || {};
    const serverUrl = clientConfig.EPIC_SERVER_URL;

    const footerLinkOnClick = useCallback(
        (e: CustomEvent<FooterLinkClickEvent>) => {
            const link = e.detail?.link;
            if (link && link?.owner === 'site' && link.relativePath) {
                e.detail.originalEvent.preventDefault();
                navigate(generateRoutePath(link.relativePath));
            }
        },
        [navigate, generateRoutePath]
    );

    return (
        <EpicGamesFooter
            domain={serverUrl}
            locale={locale}
            disableNewsletter
            countryCode={accountCountry}
            footerLinkOnClick={footerLinkOnClick}
        />
    );
};
